import React from 'react';
import { string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Heading } from '@thd-olt-component-react/core-ui';
import { VisualNavigation as VisualNavigationComponent } from '@thd-olt-component-react/visual-navigation';

export function CustomRenderedVisualNavigation({ id, title }) {
  return (
    <QueryProvider key={id} cacheKey={id}>
      {/**
       * @TODO
       * Make home.scss into a CSS modules file and use the
       * normal classnames pattern we use in the rest of our codebase.
       *
       * It's confusing that we're referencing a class that seemingly
       * comes from nowhere. (It's imported in `ConsumerHomepage.js`);
       */}
      <div className="vis-nav-wrapper">
        {title && <Heading underline title={title} />}
        <VisualNavigationComponent componentId={id} />
      </div>
    </QueryProvider>
  );
}

CustomRenderedVisualNavigation.propTypes = {
  id: string,
  title: string,
};

CustomRenderedVisualNavigation.defaultProps = {
  id: undefined,
  title: undefined,
};